var path = require('path');

module.exports.loadManifest = function () {
    if (process.env.NODE_ENV !== 'production') {
        delete require.cache[path.resolve('./build/manifest.json')];
    }

    return require('./build/manifest');
}

module.exports.formatNoneOssUrl = function (url, minioDomain) {
    if(!url) return ''
    if(url.match(minioDomain)) {
      return url
    }
    return `${minioDomain}${url}`
  }
  


// WEBPACK FOOTER //
// ./utils.js